import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest } from 'redux-saga/effects';
import { fetchDocuments } from 'redux/slice/compliance/document/Document.slice';
import { IGetDocumentsRequest } from 'redux/types/compliance/Document.types';

function* handleFetchDocumentsSaga(
  action: PayloadAction<IGetDocumentsRequest>
) {
  // try {
  //   const { filter, agencyId, ...requestBody } = action.payload;
  //   const endpoint = complianceEndPoints.GET_AGENCY_DOCUMENTS(filter, agencyId);
  //   const response: AxiosResponse<IGetDocumentsResponse> =
  //     yield HTTPClient.PostRequest(endpoint, requestBody);
  //   yield put(fetchDocumentsSuccess(response.data));
  //   message.success(response.data.message);
  // } catch (error: any) {
  //   yield* handleError(error, fetchDocumentsFailure, '');
  // }
}
export function* watchAgencyVisitSaga() {
  yield takeLatest(fetchDocuments.type, handleFetchDocumentsSaga);
}
